// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export const DefaultApplication = "app-built-in";

export const CasvisorUrl = "";

export const ShowGithubCorner = false;
export const IsDemoMode = false;

export const ForceLanguage = "";
export const DefaultLanguage = "en";

export const InitThemeAlgorithm = true;
export const ThemeDefault = {
  themeType: "default",
  colorPrimary: "#5734d3",
  borderRadius: 6,
  isCompact: false,
};

export const CustomFooter = null;

// Blank or null to hide Ai Assistant button
export const AiAssistantUrl = "https://ai.casbin.com";

// Maximum number of navbar items before switching from flat to grouped menu
export const MaxItemsForFlatMenu = 7;

// Organizations that use the dedicated, customized login/signup page (login and signup combined).
// Visiting /login/<org> for any org in this list renders ProcurementLoginPage instead of the generic
// LoginPage. All listed organizations share the exact same UI. Add an organization name here to opt it in.
export const CustomLoginOrgs = ["procurement-assistant", "virtual-employee"];

// Backwards-compatible primary organization (kept for any single-value reference/preview fallback).
export const CustomLoginOrg = CustomLoginOrgs[0];

// Whether the given organization should use the dedicated custom login/signup page.
export function isCustomLoginOrg(owner) {
  return CustomLoginOrgs.includes(owner);
}
